<div class="form-container">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="4">
        <div class="formLabelSemiBoldfs16 m-10"> Asset Management For Employee</div>
      </ion-col>
      <ion-col size="8" class="text-right">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>

    <ion-row class="m-10">
      <ion-col size="3" style="margin-left: 26px;">
        <div class="font_semibold fs-16 mb-5">
          Asset<span class="red-cl">&nbsp;*</span>
        </div>
        <mat-form-field appearance="outline" class="w-100 mat-height40">
          <mat-select [(ngModel)]="selectedAsset" placeholder="Select Asset" multiple [disabled]="true">
            <mat-option *ngFor="let asset of userListDataForAsset" [value]="asset.assetId">
              {{ asset.assetName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </ion-col>


      <ion-col size="3" style="margin-left: 26px;">
        <div class="font_semibold fs-16 mb-5">
          Band<span class="red-cl">&nbsp;*</span>
        </div>


        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <input readonly matInput [(ngModel)]="selectedBand" readonly>

        </mat-form-field>
      </ion-col>
      <ion-col size="3" style="margin-left: 26px;">
        <div class="font_semibold fs-16 mb-5">
          Select Employee<span class="red-cl">&nbsp;*</span>
        </div>



        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <input readonly matInput [(ngModel)]="selectedEmployee" readonly>

        </mat-form-field>
      </ion-col>

    </ion-row>
    <ion-row>
      <ion-col size="12">
        <div class="modal-body p-7">
          <div class="mt-2">
            <div class="cardBox card">

              <div class="card  employeeTab">
                <div class="card-body">
                  <div>

                    <div>

                      <div class="table-container" style="overflow-x: auto; max-height: 400px; overflow-y: auto;">

                        <table class="custom-table rounded-header">

                          <thead>
                            <tr>

                              <th *ngFor="let item of  assetManagementHeader" class="fs-14 font_bold cl-black">
                                <div class="p-10 verticle-center justify-content-space-between icon-style">
                                  {{ item?.label }}

                                  <div class="d-flex flex-column ml-10">

                                  </div>
                                </div>
                              </th>

                            </tr>
                          </thead>

                          <tbody>
                            <tr *ngFor="let item of userListDataForAsset; let i = index">
                              <td>{{item.assetName}}</td>
                              <td>{{item.employeeName}}</td>
                              <td>{{item.band}}</td>
                              <td>{{item.allocatingAuthorityDept}}</td>
                              <td>{{item.allocatingAuthorityName}}</td>
                              <td>
                                <!-- <mat-form-field class="w-100 mat-height40 mat-input-style">

                                  <input matInput [(ngModel)]="item.dateOfAllocation" placeholder="Select Date"
                                    readonly />
                                </mat-form-field> -->
                                {{item.dateOfAllocation}}
                              </td>
                              <td>

                                <textarea rows="2" [(ngModel)]="item.currentAssetDescription" cols="4"
                                  class="edittextarea" maxlength="255" (ngModelChange)="updateAssetData(i)" readonly>
                                </textarea>
                              </td>
                              <td>

                                <mat-form-field class="w-100 mat-height40 mat-input-style">
                                  <mat-select [(ngModel)]="item.employeeAssetStatus" name="authorityDepartmentComment"
                                    (ngModelChange)="updateAssetData(i)" [disabled]="loggedInUserRole == 'HR Admin'">

                                    <mat-option *ngFor="let option of assetOptions" [value]="option">
                                      {{formatedataVariable(option) }}
                                    </mat-option>

                                  </mat-select>
                                </mat-form-field>

                              </td>
                              <td>
                                <textarea rows="2" [(ngModel)]="item.employeeComment" cols="4" class="edittextarea"
                                  maxlength="255" (ngModelChange)="updateAssetData(i)"
                                  [disabled]="loggedInUserRole == 'HR Admin'">
                            </textarea>

                              </td>
                              <td>


                                <mat-form-field class="w-100 mat-height40 mat-input-style">
                                  <input matInput [(ngModel)]="item.employeeCommentDate" [matDatepicker]="picker"
                                    placeholder="Select Date" [disabled]="loggedInUserRole == 'HR Admin'"
                                    (ngModelChange)="updateAssetData(i)" />
                                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                  <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>

                              </td>
                              <td>

                                {{item.authorityDepartmentComment}}

                              </td>
                              <!-- {{item.authorityDepartmentComment}} -->
                              <td>
                                {{item.authorityCommentDate}}

                                <!-- <mat-form-field class="w-100 mat-height40 mat-input-style">
                                  <input matInput [(ngModel)]="item.authorityCommentDate" [matDatepicker]="picker2"
                                    placeholder="Select Date" [disabled]="loggedInUserRole != 'HR Admin'" readonly/>
                                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                  <mat-datepicker #picker2="matDatepicker"></mat-datepicker>
                                </mat-form-field> -->

                              </td>
                            </tr>
                          </tbody>

                        </table>
                      </div>
                      <div class="mt-10" style="font-weight: bold;">
                        {{userListDataForAsset?.length}} entries
                      </div>
                    </div>
                  </div>
                </div>
              </div>



              <ion-row>

              </ion-row>
              <ion-row>






              </ion-row>



            </div>
          </div>

        </div>




      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" class="text-right mt-10">
        <button class="back_btn fs-14" (click)="cancelData()">Cancel</button>
        <button type="button" class="add_btn fs-14 ml-10" [style.background-color]="buttonColorName"
          (click)="updateDataByEmployee()">
          Save
        </button>
      </ion-col>
    </ion-row>

  </div>
</div>